import { forwardRef } from 'react';
import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type IContentBlockIframeProps = IContainerProps &
  React.HTMLProps<HTMLIFrameElement> & {
    title: string;
  };

const styles = stylex.create({
  iframe: {
    width: '100%',
    height: 'calc(100vh - 32px - 72px - 32px - 24px - 32px)',
    backgroundColor: colorSchemeTokens.surfaceContainerLow,
    borderRadius: 'inherit',
    overflow: 'hidden',
  },
});

export const ContentBlockIframe = forwardRef<
  HTMLIFrameElement,
  IContentBlockIframeProps
>(function ContentBLockIframe(props, forwardedRef) {
  const { sx, title, ...other } = props;

  return (
    <iframe
      {...stylex.props(styles.iframe, sx)}
      ref={forwardedRef}
      title={title}
      {...other}
    ></iframe>
  );
});
